module.exports = __webpack_public_path__ + "8c16f45564bb89f10da9fa924532bb20.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/screenshots/MatchMeimgur.jpg
 ** module id = 204
 ** module chunks = 0
 **/